<script setup>

	const url = useRequestURL()

	const { data: page } = await useAPIFetch('ForBusiness')
	const pageMenu = page.value.body.find(item => item.specific === 'Menu')

	useHead({
		bodyAttrs: {
			class: 'no-logo'
		}
	})

	useHeadData({
		title: page.value.meta.title,
		description: page.value.meta.description,
		author: page.value.meta.author,
		copyright: page.value.meta.copyright,
		keywords: page.value.meta.keywords,
		og: page.value.meta.og,
		url: url.href
	})

</script>

<template>
	<div class="container mt-10">
		<div class="grid grid-cols-2">
			<div class="col-span-2 xl:col-span-1">
				<h1 class="text-red mb-8 h2">{{ page.attrs.title }}</h1>
				<WysiwygPerexSmall class="mb-8 xl:mb-10" :value="page.attrs.perex" />
			</div>
		</div>
		<div v-if="pageMenu" class="mb-28">
			<Button v-for="(item, index) in pageMenu.items" :key="index" :to="item.url" class="mb-2" :class="[index == pageMenu.items.length - 1 ? '' : 'mr-2 lg:mr-4']" target>{{ item.label }}</Button>
		</div>
	</div>
</template>